import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DIAM_API_PATH, deleteTeam, diamQueryKeys } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useDeleteTeam() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (teamId: string) => {
      const idToken = await getIdToken();
      return deleteTeam(apiUrl, idToken, teamId);
    },
    onSettled: (_data, _error, teamId) => {
      queryClient.invalidateQueries({
        queryKey: ['diam', 'teams', 'page'],
      });
      queryClient.invalidateQueries({
        queryKey: diamQueryKeys.team(teamId),
      });
    },
  });
}
